import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useProfileFuturesAppropriateness } from '@/hooks/queries/use-profile-futures-appropriateness';
import LoadingPage from '@/pages/loading';
import { FuturesAppropriatenessResultStatus } from '@/services/api/profile/futures-appropriateness';

const FuturesAppropriatenessTestRetakePage = () => {
  const { isLoading, data: futuresAppropriateness, reset: resetFuturesAppropriateness } = useProfileFuturesAppropriateness();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (
      futuresAppropriateness &&
      'result' in futuresAppropriateness &&
      futuresAppropriateness.result.status === FuturesAppropriatenessResultStatus.FAILED &&
      futuresAppropriateness.result.canRetake
    ) {
      resetFuturesAppropriateness();
      navigate('/futures/appropriateness-test', { replace: true });
    } else {
      navigate('/futures', { replace: true });
    }
  }, [futuresAppropriateness, isLoading, navigate, resetFuturesAppropriateness]);

  if (isLoading) return <LoadingPage />;
};
FuturesAppropriatenessTestRetakePage.displayName = 'FuturesAppropriatenessTestRetakePage';

export default FuturesAppropriatenessTestRetakePage;
